import React from 'react';
import Table from 'react-bootstrap/Table';
import bloques from './tratamientoDatosParrafos.json';

const contenidoPoliticaTratamientoDatos = () => {
  return (
    <div className="politica-tratamiento-datos text-body" style={{ fontSize: '0.875rem', lineHeight: 1.65 }}>
      <div className="mb-3 pb-2 border-bottom">
        <div className="small text-muted">
          <div><strong>Código:</strong> PL.PIGPDP.01</div>
          <div><strong>Versión:</strong> 2</div>
          <div><strong>Fecha:</strong> 16 de septiembre de 2024</div>
        </div>
      </div>
      {bloques.map((row, i) => {
        if (row.kind === 'skip') return null;
        if (row.kind === 'table_control') {
          return (
            <React.Fragment key={i}>
              <h6 className="text-dark mt-4 mb-2">CONTROL DE CAMBIOS</h6>
              <Table striped bordered hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Versión</th>
                    <th>Descripción</th>
                    <th>Motivo</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Creación de la Política de Tratamiento y Protección de Datos Personales</td>
                    <td>Cumplimiento a requisitos legales sobre regulación de Habeas Data</td>
                    <td>16 de enero de 2018</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Actualización de la Política de Tratamiento y Protección de Datos Personales</td>
                    <td>Actualización de los requisitos legales sobre regulación de Habeas Data</td>
                    <td>16 de septiembre de 2024</td>
                  </tr>
                </tbody>
              </Table>
            </React.Fragment>
          );
        }
        if (row.kind === 'h') {
          return (
            <h6 key={i} className="text-dark mt-3 mb-2 fw-semibold">
              {row.text}
            </h6>
          );
        }
        if (row.kind === 'h2') {
          return (
            <h6 key={i} className="text-dark mt-3 mb-2">
              {row.text}
            </h6>
          );
        }
        if (row.kind === 'bullet') {
          const raw = row.text.trim().startsWith('•') ? row.text.trim() : `• ${row.text.trim()}`;
          const chunks = raw.match(/•[^•]+/g) || [raw];
          return (
            <React.Fragment key={i}>
              {chunks.map((chunk, j) => {
                const t = chunk.trim();
                if (t.includes('https://')) {
                  const safe = t
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(
                      'https://www.parking.net.co/#/',
                      '<a href="https://www.parking.net.co/#/" target="_blank" rel="noopener noreferrer">https://www.parking.net.co/#/</a>'
                    );
                  return (
                    <p
                      key={`${i}-${j}`}
                      className="mb-1 ms-2"
                      dangerouslySetInnerHTML={{ __html: safe }}
                    />
                  );
                }
                return (
                  <p key={`${i}-${j}`} className="mb-1 ms-2">
                    {t}
                  </p>
                );
              })}
            </React.Fragment>
          );
        }
        if (row.kind === 'li') {
          const m = row.text.match(/^([a-z]{1,2}\))\s*(.*)$/i);
          if (m) {
            return (
              <p key={i} className="mb-1">
                <strong>{m[1]}</strong>
                {m[2]}
              </p>
            );
          }
          return (
            <p key={i} className="mb-1">
              {row.text}
            </p>
          );
        }
        if (row.kind === 'signature') {
          const lines = row.text.split(/\s*\n\s*/).filter(Boolean);
          return (
            <div key={i} className="mt-4 pt-2 border-top small">
              {lines.map((ln, j) => (
                <div key={j} className="mb-0">
                  {ln}
                </div>
              ))}
            </div>
          );
        }
        if (row.kind === 'p_link') {
          const html = row.text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(
              'https://www.parking.net.co/#/',
              '<a href="https://www.parking.net.co/#/" target="_blank" rel="noopener noreferrer">https://www.parking.net.co/#/</a>'
            );
          return (
            <p
              key={i}
              className="mb-2 text-justify"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          );
        }
        return (
          <p key={i} className="mb-2 text-justify">
            {row.text}
          </p>
        );
      })}
    </div>
  );
}

export default contenidoPoliticaTratamientoDatos;